const NOTIFY_ROLLBAR = process.env.NOTIFY_ROLLBAR

if (window.Rollbar) {
  window.Rollbar.configure({
    enabled: Boolean(NOTIFY_ROLLBAR),
    payload: {
      environment: process.env.NODE_ENV,
    },
  })
}

export default {
  configure: payload => {
    if (window.Rollbar) {
      window.Rollbar.configure({
        payload: {
          ...payload,
          environment: process.env.NODE_ENV,
        },
      })
    }
  },
  captureEvent: (level, payload) => {
    if (window.Rollbar && NOTIFY_ROLLBAR) {
      window.Rollbar.captureEvent(payload, level)
    }
  },
  log: (level, {message, err, payload}) => {
    if (window.Rollbar && NOTIFY_ROLLBAR) {
      window.Rollbar[level](message, err, payload)
    }
  },
}
